import { render, staticRenderFns } from "./salaryChart.vue?vue&type=template&id=2169c3c3&"
import script from "./salaryChart.vue?vue&type=script&lang=js&"
export * from "./salaryChart.vue?vue&type=script&lang=js&"
import style0 from "./salaryChart.vue?vue&type=style&index=0&id=2169c3c3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports